module.exports = __webpack_public_path__ + "img/box4-normal1.a1edb9b5.png";